export const ONE_MINUTE_IN_MILLISECONDS = 60000;

export const LANGUAGE_LOCALSTORAGE_KEY = 'lng';

export const LANGUAGE_OPTIONS: { key: string; val: string }[] = [
  { key: 'en', val: 'English' },
  { key: 'ba', val: 'Bahasa' },
  { key: 'ar', val: 'Arabic' },
  { key: 'fr', val: 'French' },
  { key: 'pt', val: 'Portuguese' },
  { key: 'pl', val: 'Polish' },
  { key: 'en_MY', val: 'English (Malaysia)' },
  { key: 'en_SC', val: 'English (SC)' },
  { key: 'id', val: 'Indonesian' },
  { key: 'vi', val: 'Vietnamese' },
  { key: 'ru', val: 'Russian' },
  { key: 'th', val: 'Thai' },
  { key: 'en_FR', val: 'English (France)' },
  { key: 'ar_YP', val: 'Arabic (YP)' },
  { key: 'en_aramex', val: 'English (Aramex)' },
];
